module.exports = __webpack_public_path__ + "static/media/photo28.aead0f43.jpg";